export const MAX_FILES = 15;
export const page_size_options = [10, 15, 25, 30, 50];

export const FormikRefs = {
	attachmentsFormikRef: 'attachmentsFormikRef',
	notesFormikRef: 'notesFormikRef',
	mainFormikRef: 'mainFormikRef',
};

export const MAX_LENGTH_OTHER_METHOD = 125;

export const phoneRegExp =
	/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const emailRegExp =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const route = {
	dashboard: 'dashboard',
	myRecruits: 'my-recruits',
	allRecruits: 'all-recruits',
	recruitInformation: 'recruit-information',
	recruitPortal: 'recruit-portal',
	addDetails: 'add-details',
	details: 'details',
};

export const autoCloseTimeInMilliseconds = 5000;
export const pendingToastId = 'pendingToast';
export const errorToastId = 'errorToastId';

export const DateConstants = {
	monthDateYear: 'MM/dd/yyyy',
	isoDateTime: 'yyyy-MM-dd HH:mm:ss',
};

export const FieldNames = {
	generalName: 'General - Name',
	generalPhone: 'General - Phone',
	generalFirstContactedDate: 'General - FirstContactedDate',
	generalIsProducing: 'General - IsProducing',
	generalEmail: 'General - Email',
	generalStageId: 'General - StageId',
	generalRoleId: 'General - RoleId',
	generalCity: 'General - City',
	generalStateId: 'General - StateId',
	generalCurrentCompany: 'General - CurrentCompany',
	generalRecruitingManagerId: 'General - RecruitingManagerId',
	generalNmlsId: 'General - NmlsId',
	staffTotal: 'Staff - StaffTotal',
	staffLOs: 'Staff - StaffLO',
	staffClosers: 'Staff - StaffClosers',
	staffLOAs: 'Staff - StaffLOA',
	staffUnderwriters: 'Staff - StaffUnderwriters',
	staffOfficeId: 'Staff - StaffOfficeId',
	staffProcessors: 'Staff - StaffProcessors',
	staffOthers: 'Staff - StaffOthers',
	productionMonthlyUnits: 'Production - MonthlyUnits',
	productionMonthlyVolume: 'Production - MonthlyVolume',
	productionAnnualUnits: 'Production - AnnualUnits',
	productionAnnualVolume: 'Production - AnnualVolume',
	productionConventionalLoans: 'Production - ConventionalLoans',
	productionGovernmentLoans: 'Production - GovernmentLoans',
	productionBonds: 'Production - Bonds',
	productionBroker: 'Production - Broker',
	productionJumbo: 'Production - Jumbo',
	outsideRecruiterName: 'OutsideRecruiter - Name',
	outsideRecruiterPaymentTypeId: 'OutsideRecruiter - Payment',
	outsideRecruiterIsOutsideRecruiter: 'OutsideRecruiter - IsOutsideRecruiter',
	outsideRecruiterBps: 'OutsideRecruiter - Bps',
	outsideRecruiterBpsMonths: 'OutsideRecruiter - BpsMonths',
	outsideRecruiterFlatFee: 'OutsideRecruiter - FlatFee',
	outsideRecruiterOtherMethod: 'OutsideRecruiter - OtherMethod',
};

export const DisplayFieldNames = {
	generalName: 'General - Name',
	generalPhone: 'General - Phone',
	generalFirstContactedDate: 'General - First Contacted Date',
	generalIsProducing: 'General - Producing',
	generalEmail: 'General - Email',
	generalStageId: 'General - Stage',
	generalRoleId: 'General - Role',
	generalCity: 'General - City',
	generalStateId: 'General - State',
	generalCurrentCompany: 'General - Current Company',
	generalRecruitingManagerId: 'General - Recruiting Manager',
	generalNmlsId: 'General - NMLS Id',
	staffTotal: 'Staff - Total',
	staffLOs: 'Staff - LOs',
	staffClosers: 'Staff - Closers',
	staffLOAs: 'Staff - LOAs',
	staffUnderwriters: 'Staff - Underwriters',
	staffOfficeId: 'Staff - Office',
	staffProcessors: 'Staff - Processors',
	staffOthers: 'Staff - Others',
	productionMonthlyUnits: 'Production - Monthly Units',
	productionMonthlyVolume: 'Production - Monthly Volume',
	productionAnnualUnits: 'Production - Annual Units',
	productionAnnualVolume: 'Production - Annual Volume',
	productionConventionalLoans: 'Production - Conventional Loans',
	productionGovernmentLoans: 'Production - Government Loans',
	productionBonds: 'Production - Bonds',
	productionBroker: 'Production - Broker/NQM',
	productionJumbo: 'Production - Jumbo',
	outsideRecruiterName: 'OutsideRecruiter - Name',
	outsideRecruiterPaymentTypeId: 'OutsideRecruiter - Payment Method',
	outsideRecruiterIsOutsideRecruiter: 'OutsideRecruiter - Recruiter Used',
	outsideRecruiterBps: 'OutsideRecruiter - Bps',
	outsideRecruiterBpsMonths: 'OutsideRecruiter - Bps Months',
	outsideRecruiterFlatFee: 'OutsideRecruiter - Flat Fee',
	outsideRecruiterOtherMethod: 'OutsideRecruiter - Other Method',
};

export const PromiseTypes = {
	fulFilled: 'fulfilled',
	rejected: 'rejected',
};

export const Roles = {
	adminAppAccess: 'AdminApp.Access',
	adminAppNoAccess: 'AdminApp.NoAccess',
	adminAppEditOthersOwnedRecruit: 'AdminApp.EditOthersOwnedRecruit',
	adminAppAttachRecruitDocs: 'AdminApp.AttachRecruitDocs',
	adminAppAddNotes: 'AdminApp.AddNotes',
	adminAppAddRecruit: 'AdminApp.AddRecruit',
	adminAppChangeRecruitStatus: 'AdminApp.ChangeRecruitStatus',
	adminAppAccessedUserListInclusion: 'AdminApp.AccessedUserListInclusion',
	recruitAppAccess: 'RecruitApp.Access',
	recruitAppAttachMyDocs: 'RecruitApp.AttachMyDocs',
	recruitAppManageMyNotes: 'RecruitApp.ManageMyNotes',
	recruitAppImpersonateAnyone: 'RecruitApp.ImpersonateAnyone',
};
